import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  getReports: function() {
    return axios.get(IMPROVE_CONFIG.API_URL + "/reports");
  },
  downloadFullPlatformReport: function(){
    return axios.get(IMPROVE_CONFIG.API_URL + "/full_platform_report");
  },
  exportGroupReport: function (){
        return axios.get(IMPROVE_CONFIG.API_URL + "/group-report");
  },
};